import PropTypes from "prop-types";
import { StateMachineProvider, createStore } from "little-state-machine";
import { Section } from "./Section";

createStore({ disabled: false });

export function SingleView({ product, settings, openReviewsDrawer, scrollToReviews }) {
  return (
    <StateMachineProvider>
      <Section
        settings={settings}
        product={product}
        openReviewsDrawer={openReviewsDrawer}
        scrollToReviews={scrollToReviews}
      />
    </StateMachineProvider>
  );
}

SingleView.propTypes = {
  product: PropTypes.object.isRequired,
  openReviewsDrawer: PropTypes.func,
  settings: PropTypes.object,
};
